import React, {PureComponent} from 'react';
import {withRouter} from 'react-router-dom';

import {QRCodeSVG} from 'qrcode.react';

import './qrcode.css';


class QRCode extends PureComponent {
    state = {url: ''};

    componentDidMount() {
        const {history} = this.props;
        this.unlisten = history.listen(this.update.bind(this));
        this.update();
    }

    update() {
        this.setState({url: window.location.href});
    }

    componentWillUnmount() {
        this.unlisten();
    }

    render() {
        const {size} = this.props;
        const {url} = this.state;
        return <div className='qr-code-container'>
            <QRCodeSVG value={url} size={size}/>
        </div>;
    }
}

export default withRouter(QRCode);
